import {createModel} from '@@/package/utils/ModelUtil';
import Model from "~~/package/mapper/Model";
import {ContactType} from "~~/package/mapper/contact/model/ContactType";
import {ContactInquireType} from "~~/package/mapper/contact/model/ContactInquireType";
import {PreferredContactMethodType} from "~~/package/mapper/contact/model/PreferredContactMethodType";
import {AdoptionTimelineType} from "~~/package/mapper/contact/model/AdoptionTimelineType";
import {EnterpriseInquiryTopicType} from "~~/package/mapper/contact/model/EnterpriseInquiryTopicType";

export class ContactModel extends Model {
    constructor(
        public category: ContactType = ContactType.CONTACT_US,
        public businessEmail: string = "",
        public inquireType: ContactInquireType = ContactInquireType.NONE,
        public firstName: string = "",
        public lastName: string = "",
        public fullName: string = "",
        public companyName: string = "",
        public jobTitle: string = "",
        public companyCount: string = "",
        public phoneNumber: string = "",
        public country: string = "",
        public description: string = "",
        public isPrivacyPolicy: boolean = false,
        public isMarketingPolicy: boolean = false,
        public collaborativeOrg: string = "",
        public acquisitionChannel: string = "",
        public interestService: string = "",
        public preferredContactMethod: PreferredContactMethodType | "" = "",
        public adoptionTimeline: AdoptionTimelineType | "" = "",
        public enterpriseInquiryTopics: EnterpriseInquiryTopicType[] = []
    ) {
        super();
    }

    public static create(model: Partial<ContactModel>): ContactModel {
        return createModel<ContactModel>(ContactModel, {
            ...model
        });
    }
}

export class IsNullCheckContactInfo {
    constructor(
      public email: boolean = false,
      public inquireType: boolean = false,
      public firstName: boolean = false,
      public lastName: boolean = false,
      public companyName: boolean = false,
      public jobTitle: boolean = false,
      public companyCount: boolean = false,
      public phoneNumber: boolean = false,
      public country: boolean = false,
      public visitRoute: boolean = false,
      public interestService: boolean = false,
      public preferredContactMethod: boolean = false,
      public enterpriseInquiryTopics: boolean = false,
    ) {
    }
}

export class IsNullCheckDemoRequestInfo {
    constructor(
      public email: boolean = false,
      public firstName: boolean = false,
      public companyName: boolean = false,
      public jobTitle: boolean = false,
      public phoneNumber: boolean = false,
      public visitRoute: boolean = false,
      public isPrivacyPolicy: boolean = false
    ) {
    }
}